import React, { useEffect } from "react";
import { Img } from "../../../subComponents/img";
import { Text } from "../../../subComponents/text";
import { ReadMore } from "../../../CommonComponents/readMore";
import { Subheading } from "../../../subComponents/subHeading";

import AOS from "aos";
import "aos/dist/aos.css";
import { NavLink } from "react-router-dom";

const AboutSection = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <section
        className="about_section"
        style={{ overflowX: "hidden", padding: "4rem 0" }}
      >
        {/* container left start from here */}
        <div className="about_left_container" data-aos="fade-right">
          <div className="about_left_image_container">
            <Img
              src={"/assets/images/Home/home-page-about-banner.png"}
              alt={"about Tube Flex India"}
            />
          </div>
          {/* <div className="about_left_floating_image">
            <Img
              src={"/assets/images/Home/home_about_animated_image.png"}
              alt={"about Tube Flex India images"}
            />
          </div> */}
        </div>
        {/* container left close from here */}

        {/* container right start from here */}
        <div className="about_right_container" data-aos="fade-left">
          <div className="about_right_innercontainer">
            <Subheading
              title={
                <>
                  Tube <span>Flex</span> India
                </>
              }
              style={{ color: "#c82e21", fontSize: "1rem" }}
            />
            <h1
              style={{ fontWeight: "600", marginTop: "1rem", fontSize: "2rem" }}
            >
              WE PROVIDE THE BEST
            </h1>
            <h2 style={{ fontWeight: "600" }}>Manufacturing and Accessories</h2>
            <div style={{ marginTop: "1.4rem" }}>
              <Text
                text={
                  <>
                    At Tube Flex India, we specialize in delivering high-quality
                    flexible tubing solutions and precision-engineered
                    accessories for a wide range of industrial applications. Our
                    products are designed to meet the highest standards of
                    durability, performance, and reliability, ensuring seamless
                    operations across industries.
                  </>
                }
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "1rem",
              }}
            >
              <Text
                text={
                  <>
                    With a commitment to innovation and excellence, we use
                    advanced manufacturing techniques and premium-grade
                    materials to produce tubing solutions that perform under the
                    most demanding conditions. From fluid transfer to pneumatic
                    systems, our products are built to exceed expectations.
                  </>
                }
              />
              <div style={{ width: "15rem" }}>
                <Img
                  src={
                    "https://png.pngtree.com/png-vector/20241231/ourmid/pngtree-3d-complex-machine-parts-on-transparent-background-png-image_14980578.png"
                  }
                  alt={"about Tube Flex India door"}
                  style={{
                    filter: "drop-shadow(0px 5px 4px #a5a4a4d3)",
                    opacity: "0.4",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <div style={{ width: "20rem" }}>
                <Img
                  src={
                    "https://freepngimg.com/download/technology/57032-6-machine-download-hd-png.png"
                  }
                  alt={"about Tube Flex India door"}
                  style={{
                    filter: "drop-shadow(0px 5px 4px #a5a4a4d3)",
                    opacity: "0.4",
                  }}
                />
              </div>
              <Text
                text={
                  <>
                    Our extensive range includes flexible tubes, hoses,
                    fittings, and customized accessories tailored to your
                    specific requirements. Whether you need standard solutions
                    or specialized designs, Tube Flex India is your trusted
                    partner for quality and efficiency.
                  </>
                }
              />
            </div>
            <div style={{ marginTop: "1rem" }}>
              <NavLink to={"/about-us/"}>
                <ReadMore />
              </NavLink>
            </div>
          </div>
        </div>
        {/* container right close from here */}
      </section>
    </>
  );
};
export { AboutSection };
